import { IconTrust16 } from '@cian/ui-kit';
import * as React from 'react';
import { NBSP } from '../../../constants/symbols';
import { ELabelType, ILabelsProps } from '../../../types/labels';

export const LABELS: Record<ELabelType, ILabelsProps> = {
  [ELabelType.OpenVillage]: {
    key: ELabelType.OpenVillage,
    text: 'Участник Open Village',
    color: 'red',
    tooltipTitle: 'Что такое Open Village',
    tooltipContent: `Ежегодная выставка загородных домов, которая пройдет с 12 июля по 4 августа в${NBSP}Московской области в${NBSP}КП${NBSP}Green-Lounge. Здесь можно посмотреть дома изнутри, узнать их${NBSP}стоимость, пообщаться с${NBSP}представителями компаний-застройщиков.`,
  },
  [ELabelType.Reliable]: {
    key: ELabelType.Reliable,
    text: 'Проверен Федерацией ИЖС',
    color: 'blue',
    tooltipTitle: 'Проверен Федерацией ИЖС',
    tooltipContent: `Эксперты Федерации ИЖС изучили опыт работы, репутацию компании, юридическую и${NBSP}финансовую отчётность`,
    icon: <IconTrust16 color="primary_100" />,
  },
  [ELabelType.Escrow]: {
    key: ELabelType.Escrow,
    text: 'Эскроу',
    color: 'gray',
    tooltipContent: `Деньги блокируются на счетах эскроу и перечисляются подрядчику только после завершения строительства дома и${NBSP}передачи его${NBSP}заказчику`,
  },
};
